const ITEMS = [
  ['p1', '/img/shangchang/pack/p1.webp'],
  ['p2', '/img/shangchang/pack/p2.webp'],
  ['p3', '/img/shangchang/pack/p3.webp'],
  ['p5', '/img/shangchang/pack/p5.webp'],
  ['p11', '/img/shangchang/pack/p11.webp'],
  ['p17', '/img/shangchang/pack/p17.webp'],
  ['n1', '/img/shangchang/men/n1.webp'],
  ['n2', '/img/shangchang/men/n2.webp'],
  ['n5', '/img/shangchang/men/n5.webp'],
  ['n6', '/img/shangchang/men/n6.webp'],
  ['n8', '/img/shangchang/men/n8.webp'],
  ['n9', '/img/shangchang/men/n9.webp'],
  ['n10', '/img/shangchang/men/n10.webp'],
  ['n11', '/img/shangchang/men/n11.webp'],
  ['vx', '/img/shangchang/women/x.webp'],
  ['v2', '/img/shangchang/women/v2.webp'],
  ['v3', '/img/shangchang/women/v3.webp'],
  ['v6', '/img/shangchang/women/v6.webp'],
  ['v9', '/img/shangchang/women/v9.webp'],
  ['b1', '/img/shangchang/couple/b1.webp'],
  ['b7', '/img/shangchang/couple/b7.webp'],
  ['b3', '/img/shangchang/couple/b3.webp'],
  ['b6', '/img/shangchang/couple/b6.webp'],
  ['b5', '/img/shangchang/couple/b5.webp'],
  ['gx', '/img/shangchang/gay/x.webp'],
  ['g2', '/img/shangchang/gay/g2.webp'],
  ['g3', '/img/shangchang/gay/g3.webp'],
  ['g4', '/img/shangchang/gay/g4.webp'],
  ['g8', '/img/shangchang/gay/g8.webp'],
  ['l1', '/img/shangchang/les/l1.webp'],
  ['l2', '/img/shangchang/les/l2.webp'],
  ['l3', '/img/shangchang/les/l3.webp'],
  ['l5', '/img/shangchang/les/l5.webp'],
  ['l6', '/img/shangchang/les/l6.webp'],
  ['l9', '/img/shangchang/les/l9.webp'],
];

export function randomShopProducts(count) {
  const list = ITEMS.map((row) => ({ id: row[0], pic: row[1] }));
  for (let i = list.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    const tmp = list[i];
    list[i] = list[j];
    list[j] = tmp;
  }
  return list.slice(0, count);
}
